export default class InvestRuntimeRepairData {
    constructor(id) {
        this.id = id;
        this.spareParts = 0;
        this.brigades = 0;
    }
}